App.namespace.wrap('es6.views.login.user_manager_login', function (options = {}) {
  const FormHandler = App.es6.shared.default_form_handler;

  const formSelector = '.js-login-form-handler';
  const emailInputSelector = '.email-input-field';
  const passwordInputSelector = '.password-input-field';
  const noContentClass = 'has-error-no-content';
  const passwordSectionHash = '#password';
  const prefilledEmailStorageKey = 'tgv.loginPrefilledEmail';
  let captchaService = null;

  const handleEmptyContentError = (input) => {
    input.addClass(noContentClass);

    input.one('input', () => hideError(input));
  }

  const hideError = (input) => {
    input.removeClass(noContentClass);
  }

  const onSubmitError = (errors, form) => {
    const emailInput = form.find(emailInputSelector);
    const passwordInput = form.find(passwordInputSelector);

    hideError(emailInput);
    hideError(passwordInput);

    // reCAPTCHA Enterprise tokens are single-use; drop the consumed token so a retry mints a fresh one.
    form.find('input[name="g-recaptcha-response"]').val('');

    if (errors.email && errors.email.length && errors.email[0].length === 0) {
      handleEmptyContentError(emailInput);
    }
    if (errors.password && errors.password.length && errors.password[0].length === 0) {
      handleEmptyContentError(passwordInput);
    }
    if (errors.message && !errors.email && !errors.password) {
      const $errorField = form.find(`[data-error-target="password"]`);
      $errorField.html(errors.message);
      $errorField.closest('.form-group').addClass('has-error');
    }
    if (errors['g-recaptcha-response'] && errors['g-recaptcha-response'].length) {
      const captchaSiteKey = (options && options.captcha && options.captcha.sitekey) ? options.captcha.sitekey : '';
      if (!captchaSiteKey.length) {
        throw new Error('Captcha site key is not provided');
      }

      if (captchaService === null) {
        captchaService = App.components.re_captcha(options.captcha.sitekey, 'login');
      }

      captchaService.challenge((token) => {
        form.find('input[name="g-recaptcha-response"]').val(token);
        form.submit();
      });
    }
  }

  const initMagicLinkValidation = () => {
    const FormValidation = App.es6.shared.form_validation;
    const magicLinkSection = document.getElementById('js-magic-link-section');
    if (!magicLinkSection) {
      return;
    }

    const $form = $(magicLinkSection).find('form');
    if ($form.length === 0) {
      return;
    }

    const formValidator = FormValidation({ $form });
    formValidator.init();

    $form.on('submit', (e) => {
      if (!formValidator.validate()) {
        e.preventDefault();
      }
    });
  }

  const initMagicLinkToggle = () => {
    const magicLinkSection = document.getElementById('js-magic-link-section');
    const passwordSection = document.getElementById('js-password-section');

    if (!magicLinkSection || !passwordSection) {
      return;
    }

    const showPasswordSection = () => {
      magicLinkSection.classList.add('hidden');
      passwordSection.classList.remove('hidden');
    }

    document.querySelectorAll('.js-switch-to-password').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        showPasswordSection();
      });
    });

    document.querySelectorAll('.js-switch-to-magic-link').forEach((link) => {
      link.addEventListener('click', (e) => {
        e.preventDefault();
        passwordSection.classList.add('hidden');
        magicLinkSection.classList.remove('hidden');
      });
    });

    if (window.location.hash === passwordSectionHash) {
      showPasswordSection();
      prefillPasswordEmail(passwordSection);
    }
  }

  // The check-inbox screen hands the typed address over so people don't retype it when
  // they switch to the password form. Kept out of the URL so it stays out of history and referrers.
  const prefillPasswordEmail = (passwordSection) => {
    let email = null;

    try {
      email = window.sessionStorage.getItem(prefilledEmailStorageKey);
      window.sessionStorage.removeItem(prefilledEmailStorageKey);
    } catch (e) {
      return;
    }

    if (!email) {
      return;
    }

    const emailInput = passwordSection.querySelector('input[name="email"]');
    if (emailInput && !emailInput.value) {
      emailInput.value = email;
    }
  }

  const init = () => {
    const formHandlerOptions = {
      formClass: formSelector,
      onSubmitError,
    }
    FormHandler(formHandlerOptions).init()
    initMagicLinkValidation()
    initMagicLinkToggle()
  }

  return {
    init
  }
});
